import React from 'react'
import Link from 'next/link'
import cn from 'classnames'
import { RightIcon } from '@components/icons/RightIcon'
import { BreadCrumbProps } from './interface'

function BreadCrumb({ pageList, className = '' }: BreadCrumbProps) {
  return (
    <div
      className={cn(
        'flex items-center space-x-[6px] text-sm font-sarabun font-light flex-wrap dark:text-dark-10',
        className
      )}
    >
      {pageList?.map((page, index) => {
        if (index !== pageList.length - 1)
          return (
            <div key={page.url} className='flex items-center space-x-[6px]'>
              <Link href={page.url} prefetch={false}>
                <a key={page.title}>{page.title}</a>
              </Link>
              <RightIcon width='14' height='14' />
            </div>
          )
        return (
          <div className='text-primary font-medium' key={page.title}>
            {page.title}
          </div>
        )
      })}
    </div>
  )
}

export default BreadCrumb
